export default __webpack_public_path__ + "static/media/GM.2463d416.svg";